export default {
  "root": "_root_1ueal_1",
  "--clamp": "_--clamp_1ueal_1",
  "--break-all": "_--break-all_1ueal_1",
  "--wrap-balance": "_--wrap-balance_1ueal_1",
  "--variant-title-1": "_--variant-title-1_1ueal_1",
  "--variant-title-2": "_--variant-title-2_1ueal_1",
  "--variant-title-3": "_--variant-title-3_1ueal_1",
  "--variant-title-4": "_--variant-title-4_1ueal_1",
  "--variant-title-5": "_--variant-title-5_1ueal_1",
  "--variant-title-6": "_--variant-title-6_1ueal_1",
  "--variant-featured-1": "_--variant-featured-1_1ueal_1",
  "--variant-featured-2": "_--variant-featured-2_1ueal_1",
  "--variant-featured-3": "_--variant-featured-3_1ueal_1",
  "--variant-body-1": "_--variant-body-1_1ueal_1",
  "--variant-body-2": "_--variant-body-2_1ueal_1",
  "--variant-body-3": "_--variant-body-3_1ueal_1",
  "--variant-caption-1": "_--variant-caption-1_1ueal_1",
  "--variant-caption-2": "_--variant-caption-2_1ueal_1",
  "--weight-regular": "_--weight-regular_1ueal_1",
  "--weight-medium": "_--weight-medium_1ueal_1",
  "--weight-bold": "_--weight-bold_1ueal_1",
  "--color-neutral": "_--color-neutral_1ueal_1",
  "--color-neutral-faded": "_--color-neutral-faded_1ueal_1",
  "--color-primary": "_--color-primary_1ueal_1",
  "--color-warning": "_--color-warning_1ueal_1",
  "--color-positive": "_--color-positive_1ueal_1",
  "--color-critical": "_--color-critical_1ueal_1",
  "--color-disabled": "_--color-disabled_1ueal_1",
  "--decoration-line-through": "_--decoration-line-through_1ueal_1",
  "--variant-title-1--m": "_--variant-title-1--m_1ueal_1",
  "--variant-title-2--m": "_--variant-title-2--m_1ueal_1",
  "--variant-title-3--m": "_--variant-title-3--m_1ueal_1",
  "--variant-title-4--m": "_--variant-title-4--m_1ueal_1",
  "--variant-title-5--m": "_--variant-title-5--m_1ueal_1",
  "--variant-title-6--m": "_--variant-title-6--m_1ueal_1",
  "--variant-featured-1--m": "_--variant-featured-1--m_1ueal_1",
  "--variant-featured-2--m": "_--variant-featured-2--m_1ueal_1",
  "--variant-featured-3--m": "_--variant-featured-3--m_1ueal_1",
  "--variant-body-1--m": "_--variant-body-1--m_1ueal_1",
  "--variant-body-2--m": "_--variant-body-2--m_1ueal_1",
  "--variant-body-3--m": "_--variant-body-3--m_1ueal_1",
  "--variant-caption-1--m": "_--variant-caption-1--m_1ueal_1",
  "--variant-caption-2--m": "_--variant-caption-2--m_1ueal_1",
  "--weight-regular--m": "_--weight-regular--m_1ueal_1",
  "--weight-medium--m": "_--weight-medium--m_1ueal_1",
  "--weight-bold--m": "_--weight-bold--m_1ueal_1",
  "--variant-title-1--l": "_--variant-title-1--l_1ueal_1",
  "--variant-title-2--l": "_--variant-title-2--l_1ueal_1",
  "--variant-title-3--l": "_--variant-title-3--l_1ueal_1",
  "--variant-title-4--l": "_--variant-title-4--l_1ueal_1",
  "--variant-title-5--l": "_--variant-title-5--l_1ueal_1",
  "--variant-title-6--l": "_--variant-title-6--l_1ueal_1",
  "--variant-featured-1--l": "_--variant-featured-1--l_1ueal_1",
  "--variant-featured-2--l": "_--variant-featured-2--l_1ueal_1",
  "--variant-featured-3--l": "_--variant-featured-3--l_1ueal_1",
  "--variant-body-1--l": "_--variant-body-1--l_1ueal_1",
  "--variant-body-2--l": "_--variant-body-2--l_1ueal_1",
  "--variant-body-3--l": "_--variant-body-3--l_1ueal_1",
  "--variant-caption-1--l": "_--variant-caption-1--l_1ueal_1",
  "--variant-caption-2--l": "_--variant-caption-2--l_1ueal_1",
  "--weight-regular--l": "_--weight-regular--l_1ueal_1",
  "--weight-medium--l": "_--weight-medium--l_1ueal_1",
  "--weight-bold--l": "_--weight-bold--l_1ueal_1",
  "--variant-title-1--xl": "_--variant-title-1--xl_1ueal_1",
  "--variant-title-2--xl": "_--variant-title-2--xl_1ueal_1",
  "--variant-title-3--xl": "_--variant-title-3--xl_1ueal_1",
  "--variant-title-4--xl": "_--variant-title-4--xl_1ueal_1",
  "--variant-title-5--xl": "_--variant-title-5--xl_1ueal_1",
  "--variant-title-6--xl": "_--variant-title-6--xl_1ueal_1",
  "--variant-featured-1--xl": "_--variant-featured-1--xl_1ueal_1",
  "--variant-featured-2--xl": "_--variant-featured-2--xl_1ueal_1",
  "--variant-featured-3--xl": "_--variant-featured-3--xl_1ueal_1",
  "--variant-body-1--xl": "_--variant-body-1--xl_1ueal_1",
  "--variant-body-2--xl": "_--variant-body-2--xl_1ueal_1",
  "--variant-body-3--xl": "_--variant-body-3--xl_1ueal_1",
  "--variant-caption-1--xl": "_--variant-caption-1--xl_1ueal_1",
  "--variant-caption-2--xl": "_--variant-caption-2--xl_1ueal_1",
  "--weight-regular--xl": "_--weight-regular--xl_1ueal_1",
  "--weight-medium--xl": "_--weight-medium--xl_1ueal_1",
  "--weight-bold--xl": "_--weight-bold--xl_1ueal_1"
};import "ni:sha-256;lmCcAEK_ZdudP3Wos6UfXzyfGePSvK-pAWM5Oe3Lrzk";